import { Navigate } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import useAuthStore from '../../store/useAuthStore'
import LoadingSpinner from '../common/LoadingSpinner'

const ProtectedRoutes = ({ allowedRoles, children }) => {
  const { user, isAuthenticated, getMe, logout } = useAuthStore()
  const [isLoading, setIsLoading] = useState(true)
  const accessToken = localStorage.getItem('accessToken')
  const hasValidated = useRef(false)

  useEffect(() => {
    const validateToken = async () => {
      if (accessToken && isAuthenticated && !hasValidated.current) {
        hasValidated.current = true
        try {
          await getMe()
        } catch (error) {
          console.error('Token validation failed:', error)
          await logout()
          hasValidated.current = false
        }
      }
      setIsLoading(false)
    }

    validateToken()
  }, [accessToken, isAuthenticated, getMe, logout])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default ProtectedRoutes
